import { DayOfWeek } from "../../models";

export const DAYS_ORDER = [
	DayOfWeek.Monday,
	DayOfWeek.Tuesday,
	DayOfWeek.Wednesday,
	DayOfWeek.Thursday,
	DayOfWeek.Friday,
	DayOfWeek.Saturday,
	DayOfWeek.Sunday
];

export enum TelehealthType {
	Global = "Global",
	Local = "Local"
}
export interface TelehealthSchedulePrompt {
	id: number;
	clinicId: number;
	dayOfWeek: string;
	allowTelehealth: boolean;
	waitTimePrompt: boolean;
	cancellationPrompt: boolean;
}

export interface TelehealthSchedule {
	id: number;
	dayOfWeek: string;
	startTime: string;
	endTime: string;
	clinicId: number;
	telehealthType: TelehealthType;
	active: boolean;
	prompts?: TelehealthSchedulePrompt[];
}

export interface ScheduleRangeValidationResult {
	hasErrors: boolean;
	invalidGlobalScheduleIds: Set<number>;
	invalidLocalScheduleDays: Set<string>;
	globalMessage: string;
	localMessage: string;
}

export const headerCellSx = { fontWeight: "bold" };
export const groupBorderSx = { borderLeft: "1px solid #e0e0e0" };
export const colBorderSx = { borderRight: "1px solid #e0e0e0" };
export const PROMPTING_BG = "#dce8f5";
export const ERROR_BG = "#fdecea";
